module.exports = __webpack_public_path__ + "img/Asset-21blackee-300x73.ce5ee66f.png";